import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { KmsService } from '../../../kms.service';
import { InstanceModuleService } from '../../../serves/instance/instance.module';
import { SwMassageBoxService } from '../../../../../librarys/serves/sw-massage-box.service';
import { SwModalframeComponent } from '../../../../../librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
import { KmgMapComponent } from '../../kmg-map/kmg-map.component';
import { SwCreateModalComponentService } from 'src/app/librarys/serves/sw-create-modal-component.service';
import { KmsEnum } from '../../../serves/kms-enum';
import { EditDatasourceComponent } from '../../edit-datasource/edit-datasource.component';
import { environment } from 'src/environments/environment';
declare var $;
@Component({
  selector: 'app-tab-info-add',
  templateUrl: './tab-info-add.component.html',
  styleUrls: ['./tab-info-add.component.css']
})
export class TabInfoAddComponent implements OnInit {
  // 模态框标题名称
  title = '';
  // 时间字段key
  timeFiledName:string = '';
  // 排序号
  sortNum:number = null;
  // 属性配置
  attrDatas:any = {}
  // 表单详情信息
  formData: any = {};
  // 表单验证失败的字段名数组
  errorList = [];
  // 表单时间月数据
  monthArr = new Array(12).fill('').map( (item, index) => index+1);
  // 表单时间天数据
  dayArr = new Array(31).fill('').map((item, index) => index + 1);
  // 相关实体初始值
  initInstances = [];
  // 选择的相关实体数据
  selectedInstances = [];
  // 设置为节点名称的属性标识
  nodeNameKey:string = '';
  // 地理位置坐标
  selectedPlaces:any = [];
  // 地理位置属性信息
  placeAttr:any = {};
  // 表单控件类型
  formControlTypes = KmsEnum.FORM_CONTROL_TYPES;
  // 数据来源
  sourceList:any = [];
  // 待删除的数据来源id
  deleteIds:any = [];
  // 输入参数 
  @Input() param: any;
  // 抛出事件
  @Output() callback = new EventEmitter();
  @ViewChild('modal') modal: SwModalframeComponent;
  constructor(
      private kmsService: KmsService,
      private message: SwMassageBoxService,
      private instanceModuleService: InstanceModuleService,
      private create: SwCreateModalComponentService,
  ) { }

  ngOnInit() {
    if (this.param) {
      this.attrDatas = JSON.parse(JSON.stringify(this.param.attrDatas));
      // 获取时间类型的字段key
      let timeField = this.attrDatas.attrChild ? this.attrDatas.attrChild.filter(item => item.fieldType == this.formControlTypes.dateRemark || item.fieldType == this.formControlTypes.date) : [];
      this.timeFiledName = timeField.length>0 ? timeField[0].englishCode : '';
      // 获取被设置为节点名称的字段key
      let items = this.attrDatas.attrChild.filter(item => item.isNodeName);
      this.nodeNameKey = items.length>0 ? items[0].englishCode : '';
      // 表单初始化
      if (this.param.upOrAdd == 'Add') {
        this.param.nodeId = this.instanceModuleService.uuid2();
        this.title = `新增${this.attrDatas.attributeName}`;
        this.formData = {};
        this.attrDatas.attrChild.forEach(el => {
          // 选择框类型（相关实体）
          if(el.fieldType == this.formControlTypes.selectBox){
            this.initInstances = [];
            this.selectedInstances = [];
          }
          // 带备注日期类型
          else if(el.fieldType == this.formControlTypes.dateRemark){
            this.formData[el.englishCode] = '';
            this.formData[el.englishCode+'Note'] = '';
          }
          // 地理位置（带备注 或 不带备注）
          else if(el.fieldType == this.formControlTypes.geoRemark || el.fieldType == this.formControlTypes.geo){
            this.placeAttr = el;
            this.selectedPlaces = [{
              category: 2,
              targetId: this.param.nodeId,
              relationshipId: this.placeAttr.attributeId,
              relationshipName: this.placeAttr.attributeName,
              englishCode: this.placeAttr.englishCode,
              geo: '',
              placeName: '',
              placeNote: ''
            }];
          }
          else{
            this.formData[el.englishCode] = '';
          }
        });
        this.sortNum = null;
      } else {
        this.title = `编辑${this.attrDatas.attributeName}`;
        this.kmsService.queryCompositeAttributeById(this.param.nodeId).subscribe(
          res => {
            if(res.code == '200'){
              this.formData = {};
              let properties = res.data.properties;
              this.sortNum = properties['sortNum'] ? Number(properties['sortNum']) : null;
              this.attrDatas.attrChild.forEach(el => {
                // 选择框类型（相关实体）
                if(el.fieldType == this.formControlTypes.selectBox){
                  this.initInstances = res.data.relevantRelationships;
                  this.selectedInstances = res.data.relevantRelationships;
                }
                // 带备注日期类型
                else if(el.fieldType == this.formControlTypes.dateRemark){
                  this.formData[el.englishCode] = properties[el.englishCode];
                  this.formData[el.englishCode+'Note'] = properties[el.englishCode+'Note'];
                }
                // 地理位置
                else if(el.fieldType == this.formControlTypes.geoRemark || el.fieldType == this.formControlTypes.geo){
                  this.placeAttr = el;
                  if(res.data.places.length > 0){
                    this.selectedPlaces = res.data.places;
                  }else{
                    this.selectedPlaces = [{
                      category: 2,
                      targetId: this.param.nodeId,
                      relationshipId: this.placeAttr.attributeId,
                      relationshipName: this.placeAttr.attributeName,
                      englishCode: this.placeAttr.englishCode,
                      geo: '',
                      placeName: '',
                      placeNote: ''
                    }];
                  }
                }
                else{
                  this.formData[el.englishCode] = properties[el.englishCode];
                }
              });
              this.sourceList = res.data.compositeRels ? res.data.compositeRels : [];
              if(this.sourceList.length>0){
                this.sourceList.forEach(element => {
                  element['uuid'] = this.instanceModuleService.uuid2();
                });
              }
            }
          }
        )
      }
    }
  }

  // 表单保存信息
  onSubmit() {
    // 拼接参数
    let compositeRels:any = [];
    if(this.sourceList.length>0){
      this.sourceList.forEach(element => {
        compositeRels.push({
          "compositeNodeId": this.param.nodeId,
          "relationshipId": this.attrDatas.englishCode,
          "relationshipName": this.attrDatas.attributeName,
          "sortNum": this.attrDatas.sortNum,
          "materialId": element.materialId,
          "pageNum": element.pageNum,
          "relPageNum": element.relPageNum,
          "sourceMaterial": element.sourceMaterial,
          "sourceText": element.sourceText,
          "datasource": element.datasource
        })
      });
    }else{
      if(environment.isSourceRequired){
        this.message.info('请录入数据来源！');
        return;
      }else{
        compositeRels.push({
          "compositeNodeId": this.param.nodeId,
          "relationshipId": this.attrDatas.englishCode,
          "relationshipName": this.attrDatas.attributeName,
          "sortNum": this.attrDatas.sortNum,
          "materialId": '',
          "pageNum": 1,
          "relPageNum": 1,
          "sourceMaterial": '',
          "sourceText": '',
          "datasource": ''
        })
      }
    }
    let params = {
      "compositeAttributeId": this.param.nodeId,
      "compositeRels": compositeRels,
      "instanceId": this.param.instanceId,
      "properties": {
        nodeId: this.param.nodeId,
        nodeName: this.nodeNameKey ? this.formData[this.nodeNameKey] : ''
      },
      "relevantRelationships": this.selectedInstances,
      "places": []
    }
    for(let key in this.formData){
      params.properties[key] = this.formData[key];
    }
    // 设置sortNum 
    if(this.sortNum){
      params.properties['sortNum'] = this.sortNum;
    }else{
      params.properties['sortNum'] = this.getSortNum();
    }
    // 调用保存或编辑方法
    let func;
    if(this.param.upOrAdd == 'Add'){
      func = this.kmsService.saveCompositeAttribute(params);
    }else{
      func = this.kmsService.updateCompositeAttribute(params);
    }
    func.subscribe(
      result => {
        if (result.code == 200) {
          // 处理地理位置信息方法
          let places = this.selectedPlaces.filter(item => (item.geo || $.trim(item.placeNote)));
          places.forEach(item => {
            item.placeName = $.trim(item.placeName);
            item.placeNote = $.trim(item.placeNote);
            if(!item.placeName && item.placeNote){
              item.placeName = item.placeNote;
            }
          })
          let geoRelsArr = [
            {
              "targetId": this.param.nodeId,
              "relationshipId": this.placeAttr.attributeId,
              "places": places
            }
          ]
          this.kmsService.updateCoordRelationship(geoRelsArr).subscribe(
            res => {
                if(res.code == '200'){
                  this.message.success('数据保存成功！');
                  this.modal.toggle();
                  this.callback.emit(true);
                }
            }
          )
        } else {
            this.message.waring(result.msg);
        }
      }
    )
  }

  // 根据时间字段设置排序号
  getSortNum(){
    // 未设置时间的，排序号设置一个最大的10位数
    if(!this.formData[this.timeFiledName]){
      return 999999999;
    }
    let timeStr = this.formData[this.timeFiledName];
    let year = parseInt(this.getYearOrMonthOrDay('year',timeStr));
    let month = this.getYearOrMonthOrDay('month',timeStr);
    let day = this.getYearOrMonthOrDay('day',timeStr);
    // 若为正数年份
    if(year>0){
      if(month){
        month = parseInt(month)>9 ? month : ('0' + month);
      }else{
        month = '00';
      }
      if(day){
        day = parseInt(day)>9 ? day : ('0' + day);
      }else{
        day = '00';
      }
      let sortNum = year + '' + month + '' + day + '0';
      return parseInt(sortNum);
    }else{
      if(month){
        month = parseInt(month);
      }else{
        month = 0;
      }
      if(day){
        day = parseInt(day);
      }else{
        day = 0;
      }
      let sortNum = year + '' + (99 - month) + '' + (99 - day) + '0';
      return parseInt(sortNum);
    }
  }

  // 表单，日期年月日赋值
  getYearOrMonthOrDay(key, dateStr) {
    let data;
    if(!dateStr) {
        data = {
            'year':'',
            'month':'',
            'day':''
        }
    } else {
        const dateArr = dateStr.split('/');
        const len = dateArr.length;
        data = {
            'year':len > 0 ? dateArr[0] : '',
            'month':len > 1 ? dateArr[1] : '',
            'day':len > 2 ? dateArr[2] : ''
        }
    }
    return data[key];
  }

  // 表单，获取年号
  getTime(keyName) {
      let parent = $('input[id="' + keyName + '"]').parent();
      const value = $.trim(parent.find('.year').val());
      if (value) {
        if (value > 1949) {
          this.formData[keyName+'Note'] = `${value}年`;
        }else{
          this.kmsService.getInstanceTimeNoteByYear(value).subscribe(
            data => {
                if (data.code == '200') {
                    const res = data.data;
                    this.formData[keyName+'Note'] = res;
                } else {
                    console.log(data.msg);
                }
            }
          );
        }
      }
  }

  // 表单，监听时间输入框的变化，判断是否合法
  getDateStr(keyName) {
    let parent = $('input[id="' + keyName + '"]').parent();
    const yearValue = parent.find('.year').val();
    const monthValue = parent.find('.month').val();
    const dayValue = parent.find('.day').val();
    let res = this.instanceModuleService.validateTime(yearValue, monthValue, dayValue);
    this.formData[keyName] = res.timeStr;
    if (!res.isValid) {
        if (this.errorList.indexOf(keyName) < 0) {
            this.errorList.push(keyName);
            parent.parent().find('.tip-error').removeClass('hidden');
            parent.find('.year,.month,.day').addClass('input-error');
        }
    } else {
      const index = this.errorList.indexOf(keyName);
      if (index >= 0) {
          this.errorList.splice(index, 1);
          parent.parent().find('.tip-error').addClass('hidden');
          parent.find('.year,.month,.day').removeClass('input-error');
      }
    }

    // 修改排序号
    this.sortNum = this.getSortNum();
  }

  // 相关实体选择发生改变
  selectChange(event){
    this.selectedInstances = event;
  }

  // 展示选择地理位置弹框
  showMapModal() {
    let params = [];
    if(this.selectedPlaces.length>0){
      this.selectedPlaces.forEach(element => {
        params.push({
          category: 2,
          targetId: this.param.nodeId,
          relationshipId: this.placeAttr.attributeId,
          relationshipName: this.placeAttr.attributeName,
          englishCode: this.placeAttr.englishCode,
          geo: element.geo,
          attributeChName: element.placeName,
          attributeChNameOther: element.placeNote
        })
      });
    }else{
      params = [{
        category: 2,
        targetId: this.param.nodeId,
        relationshipId: this.placeAttr.attributeId,
        relationshipName: this.placeAttr.attributeName,
        englishCode: this.placeAttr.englishCode,
        geo: '',
        attributeChName: '',
        attributeChNameOther: ''
      }]
    }
    this.create.createModal(KmgMapComponent, params, this.mapFunction.bind(this));
  }

  // 地图服务回调函数
  mapFunction(event){
    if (event.data && event.data.length>0) {
      this.selectedPlaces = JSON.parse(JSON.stringify(event.data));
      this.selectedPlaces.forEach(element => {
        element['placeName'] = element.attributeChName;
        element['placeNote'] = element.attributeChNameOther;
      });
    }
    // 若不存在选中的地理位置，则清空该字段值,
    else{
      this.selectedPlaces = [{
        category: 2,
        targetId: this.param.nodeId,
        relationshipId: this.placeAttr.attributeId,
        relationshipName: this.placeAttr.attributeName,
        englishCode: this.placeAttr.englishCode,
        geo: '',
        placeName: '',
        placeNote: ''
      }]
    }
  }

  // 添加一条地理位置信息
  addRow(){
    this.selectedPlaces.push({
      category: 2,
      targetId: this.param.nodeId,
      relationshipId: this.placeAttr.attributeId,
      relationshipName: this.placeAttr.attributeName,
      englishCode: this.placeAttr.englishCode,
      geo: '',
      placeName: '',
      placeNote: ''
    });
  }

  // 删除一条地理位置信息
  deleteRow(i){
    let len = this.selectedPlaces.length;
    if(len > 1){
      this.selectedPlaces.splice(i, 1);
    }else{
      this.selectedPlaces = [{
        category: 2,
        targetId: this.param.nodeId,
        relationshipId: this.placeAttr.attributeId,
        relationshipName: this.placeAttr.attributeName,
        englishCode: this.placeAttr.englishCode,
        geo: '',
        placeName: '',
        placeNote: ''
      }]
    }
  }

  // 查看来源方法
  handleSourceEditClick() {
    const data = {
        state: 'edit',
        sourceList: this.sourceList
    }
    this.create.createModal(EditDatasourceComponent, data, this.editDatasourceFunction.bind(this));
  }

  // 编辑属性来源回调函数
  editDatasourceFunction(event){
    this.sourceList = event.data;
    this.deleteIds = this.deleteIds.concat(event.deleteIds);
  }
}
